module.exports = __webpack_public_path__ + "img/oil-chart.a6b1d945.png";